<rt-evaluate-candidate-button
  [rating]="candidate().myLastRating"
  [newEvaluationDropdownTpl]="newEvaluationDropdownTpl"
  [editEvaluationDropdownTpl]="editEvaluationDropdownTpl"
  [onlyQuickEvaluation]="!isEvaluationFormsEntitled()"
  [rtWalkthroughOriginStepId]="'walkthrough-step-evaluate-candidate-2'"
  (newEvaluation)="onAddQuickEvaluation()"
/>

<ng-template #newEvaluationDropdownTpl>
  <rt-add-evaluation-dropdown
    [offers]="offers()"
    [candidateId]="candidate().id"
    [hasBackAction]="!!candidate().myLastRating"
    [asDropdownTemplate]="!!candidate().myLastRating"
    (close)="closeOverlay()"
    (addEvaluation)="onAddEvaluation($event)"
    (addQuickEvaluation)="onAddQuickEvaluation()"
    (goBack)="nestedDropdownParent()?.prevTemplate()"
  />
</ng-template>

<ng-template #editEvaluationDropdownTpl>
  <rt-edit-quick-evaluation-dropdown
    [candidate]="candidate()"
    [width]="DropdownWidth.LargeXX"
    [addAnotherEvaluationTpl]="newEvaluationDropdownTpl"
    (openInEvaluationTab)="openInEvaluationTab.emit()"
  />
</ng-template>
